<template>
  <div class="">
    <b-modal id="modal-6" title="Shipping Address" hide-footer>
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form
          class="custform"
          role="form"
          @submit.prevent="handleSubmit(handleClick)"
        >
          <div class="">
            <label>Full Name<span class="clr-red">*</span></label>
            <base-input
              v-model="name"
              placeholder="Enter full name"
              name="Name"
              :rules="{ required: true, alpha_spaces: true }"
            ></base-input>
          </div>
          <div class="">
            <label>Phone Number<span class="clr-red">*</span></label>
            <base-input
              v-model="number"
              placeholder="Enter phone number"
              name="Phone Number"
              :rules="{ required: true, numeric: true, min: 10, max: 10 }"
            ></base-input>
          </div>

          <div class="">
            <label>Email<span class="clr-red">*</span></label>
            <base-input
              v-model="email"
              placeholder="Enter email"
              name="Email"
              :rules="{ required: true, email: true }"
            ></base-input>
          </div>

          <div class="">
            <label>Address<span class="clr-red">*</span></label>
            <base-input
              v-model="address1"
              placeholder="Enter address"
              name="Address"
              :rules="{ required: true }"
            ></base-input>
          </div>

          <div class="">
            <label>Landmark</label>
            <base-input
              v-model="landmark"
              placeholder="Enter landmark"
              name="Landmark"
            ></base-input>
          </div>

          <div class="">
            <label>Town/City<span class="clr-red">*</span></label>
            <base-input
              v-model="towncity"
              placeholder="Enter towncity"
              name="Town/City"
              :rules="{ required: true, alpha_spaces: true }"
            ></base-input>
          </div>

          <div class="">
            <label>Pincode<span class="clr-red">*</span></label>
            <base-input
              v-model="pincode"
              placeholder="Enter pincode"
              name="Pincode"
              :rules="{ required: true, numeric: true, max: 6, min: 6 }"
            ></base-input>
          </div>

          <div class="">
            <label>State<span class="clr-red">*</span></label>
            <base-input
              v-model="state"
              placeholder="Enter state"
              name="State"
              :rules="{ required: true, alpha_spaces: true }"
            ></base-input>
          </div>
          <div class="flex pt-5 justify-center">
            <b-button type="primary" native-type="submit" variant="primary"
              >Proceed To Pay</b-button
            >
          </div>
        </b-form>
      </validation-observer>
    </b-modal>
    <!-- <div class="absolute bg-design1 mob-hidden">
      <img
        src="../../../../assets/images/bg-des/bgd1.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design2 mob-hidden">
      <img src="../../../../assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
    </div>
    <div class="absolute bg-design3 mob-hidden">
      <img
        src="../../../../assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="bottom-44 right-0 absolute mob-hidden">
      <img
        src="../../../../assets/images/caregiver/medc-dots.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div> -->
    <div class="container px-10">
      <div class="mb-4">
        <p
          class="title fsize36 sm-fsize24 lg:font-normal md:font-normal font-bold"
        >
          Shopping Cart
        </p>
        <hr />
      </div>
      <div class="lg:flex md:flex">
        <div
          class="lg:w-2/3 w-full px-4 rounded-xl"
          v-if="cartData.data.result == 0"
        >
          <NoData />
        </div>
        <div class="lg:w-2/3 w-full rounded-xl" v-else>
          <!-- <div class="bg-white">
            <div class="cust-shadow-FAQ p-6 rounded-lg w-full my-6">
              <div class="lg:flex lg:flex-wrap flex w-full">
                <div class="flex items-center w-full">
                  <div class="md:w-1/5 w-1/2 flex items-center">
                    <div class="">
                      <img
                        src="../../../assets/images/coach/Frame 1000002205.png"
                        alt="Icon"
                        class="cartcrsimg rounded-lg mx-auto"
                      />
                    </div>
                  </div>
                  <div class="md:flex items-center w-4/5 justify-between">
                    <div class="">
                      <div class="pl-6">
                        <p
                          class="text-black cartname font-bold text-base ellipsis-2 pr-4"
                        >
                          fds
                        </p>
                        <p
                          class="font-medium cartfooter sm-fsize12 md:mt-1 mt-1"
                        >
                          By few
                        </p>
                      </div>
                    </div>

                    <div class="flex gap-2 md:w-2/5 pl-6 md:pl-0">
                       <p
                        class="md:text-center text-sm font-normal text-primary line-through"
                      >
                        Rs {{ items.price ? items.price : 0 }}
                      </p> 
                      <p
                        class="md:text-center text-lg font-normal text-primary line-through"
                      >
                        Rs. 1
                      </p>
                      <p
                        class="md:text-center text-lg font-bold text-primary md:mt-0 mt-2"
                      >
                        Rs. 2
                      </p>
                    </div>
                  </div>
                  <div class="w-1/5 flex justify-center">
                    <feather-icon
                      block
                      icon="Trash2Icon"
                      svgClasses="w-7"
                      class="ftr-bin-clr cursor-pointer"
                    ></feather-icon>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div
            class="cust-shadow-FAQ p-3 rounded-lg w-full my-6"
            v-for="(item, index) in cartData.data.result"
            :key="index"
            v-if="!item.productId[0].isDeleted && item.productId[0].sku > 0"
          >
            <div class="lg:flex lg:flex-wrap flex w-full">
              <div class="lg:flex md:block gap-2 items-center w-full mb-4">
                <div class="md:w-1/5 lg:w-1/5 flex items-center">
                  <div class="m-auto">
                    <!-- <img
                      :src="$imageURL + '/' + item.productId[0].productImage"
                      alt="Icon"
                      class="cartcrsimg rounded-lg mx-auto"
                    /> -->
                    <img
                      v-if="item.productId[0].productImage"
                      :src="`${$imageURL}/${item.productId[0].productImage}`"
                      alt="Icon"
                      class="cartcrsimg rounded-lg mx-auto"
                    />
                    <img
                      v-else
                      :src="$noIMG"
                      alt="Icon"
                      class="cartcrsimg rounded-lg mx-auto"
                    />
                  </div>
                </div>
                <div class="md:flex items-center lg:w-2/3 justify-between">
                  <div class="lg:w-2/3 md:w-2/3">
                    <div class="lg:pl-4 md:pl-4">
                      <p
                        class="text-black cartname lg:pt-0 md:pt-0 pt-2 font-bold text-base ellipsis-2"
                      >
                        {{ item.productId[0].name }}
                      </p>
                      <p class="font-medium cartfooter sm-fsize12 md:mt-1 mt-1">
                        {{ item.productId[0].brand.name }}
                        <!-- {{
                          items.author
                            .map((data) => {
                              if (data.userId) {
                                return (
                                  data.userId.firstname +
                                  " " +
                                  data.userId.lastname
                                );
                              }
                            })
                            .toString()
                        }} -->
                      </p>
                    </div>
                  </div>

                  <div class="flex gap-2 md:w-2/5 lg:pl-0 md:pl-0">
                    <p
                      class="md:text-center text-lg font-bold text-primary md:mt-0 mt-2"
                    >
                      <!-- Rs. {{ items.discountPrice ? items.discountPrice : 0 }} -->
                      <!-- Rs. {{ item.price - (item.price * item.discount) / 100 }} -->
                      <span class="line-through clr777 fsize12">
                        Rs.
                        {{ (item.productId[0].price * item.qnty).toFixed(2) }}
                      </span>
                      <br />
                      <span class="fsize16">
                        Rs.
                        {{
                          // item.productId[0].membershipDisc[membershipName] !=
                          //   null ||
                          item.productId[0].membershipDisc.hasOwnProperty(
                            membershipName
                          ) &&
                          item.productId[0].membershipDisc[membershipName] !=
                            "" &&
                          membershipName
                            ? (
                                (
                                  item.productId[0].discountPrice -
                                  (item.productId[0].discountPrice *
                                    parseInt(
                                      item.productId[0].membershipDisc[
                                        membershipName
                                      ]
                                    )) /
                                    100
                                ).toFixed(2) * item.qnty
                              ).toFixed(2)
                            : (
                                item.productId[0].discountPrice * item.qnty
                              ).toFixed(2)
                        }}
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  class="lg:w-1/6 md:w-1/6 lg:pt-0 md:pt-0 pt-2 flex gap-2 lg:justify-center"
                >
                  <el-button
                    class="custbtn"
                    style="cursor: pointer"
                    size="10"
                    type="danger"
                    plain
                    icon="el-icon-minus"
                    @click="handleDcr(item)"
                  ></el-button>
                  <input
                    type="text"
                    style="
                      width: 60px;
                      text-align: center;
                      border: 2px solid rgb(213, 212, 212);
                      border-radius: 5px;
                    "
                    disabled
                    v-model="item.qnty"
                  />
                  <el-button
                    class="custbtn bg-primary"
                    style="cursor: pointer"
                    plain
                    size="10"
                    type="primary"
                    icon="el-icon-plus"
                    @click="handleInc(item)"
                  ></el-button>
                </div>
                <div
                  class="lg:w-24 md:w-24 lg:pt-0 md:pt-2 pt-2 flex lg:justify-center md:justify-start"
                >
                  <feather-icon
                    block
                    icon="Trash2Icon"
                    svgClasses="w-7"
                    class="ftr-bin-clr cursor-pointer"
                    @click="removeCart(item)"
                  ></feather-icon>
                </div>
              </div>
            </div>
            <span
              class="font-semibold text-success fsize14 lg:pl-0 md:pl-0"
              v-if="
                parseInt(item.productId[0].membershipDisc[membershipName]) > 0
              "
            >
              <!-- Rs. {{ item.price ? item.price : 0 }} -->
              <span class="text-black mr-1"> Product discount </span>
              {{ item.productId[0].discount }}% off
              <span class="text-black mr-1"> + </span>
              discount of

              {{ parseInt(item.productId[0].membershipDisc[membershipName]) }}%
              <span class="text-black ml-1">
                on your {{ membershipName }} plan</span
              >
            </span>
            <span
              class="md:text-center text-success font-semibold fsize14"
              v-else-if="parseInt(item.productId[0].discount)"
            >
              <!-- Rs. {{ item.price ? item.price : 0 }} -->
              <span class="text-black">Product discount</span>
              {{ item.productId[0].discount }}% off
            </span>
          </div>
          <div
            class="cust-shadow-FAQ p-6 rounded-lg w-full my-6"
            v-for="(item, index) in cartData.data.result"
            :key="index"
            v-if="item.productId[0].sku < 1"
          >
            <div class="lg:flex lg:flex-wrap flex w-full">
              <div class="flex items-center w-full">
                <div class="md:w-1/5 w-1/2 flex items-center">
                  <div class="blur">
                    <img
                      v-if="item.productId[0].productImage"
                      :src="`${$imageURL}/${item.productId[0].productImage}`"
                      alt="Icon"
                      class="cartcrsimg rounded-lg mx-auto"
                    />
                    <img
                      v-else
                      :src="$noIMG"
                      alt="Icon"
                      class="cartcrsimg rounded-lg mx-auto"
                    />
                  </div>
                </div>

                <div class="md:flex items-center w-4/5 justify-between">
                  <div class="blur">
                    <div class="pl-6">
                      <p
                        class="text-black cartname font-bold text-base ellipsis-2 pr-4"
                      >
                        {{ item.productId[0].name }}
                      </p>
                      <p class="font-medium cartfooter sm-fsize12 md:mt-1 mt-1">
                        {{ item.productId[0].brand.name }}
                      </p>
                    </div>
                  </div>
                  <div class="justify-between">
                    <p class="fsize30 sm-fsize25">Out of Stock....</p>
                  </div>
                </div>

                <div class="w-24 flex justify-center">
                  <feather-icon
                    block
                    icon="Trash2Icon"
                    svgClasses="w-7"
                    class="ftr-bin-clr cursor-pointer"
                    @click="removeCart(item)"
                  ></feather-icon>
                </div>
              </div>
            </div>
          </div>
          <div
            class="cust-shadow-FAQ p-6 rounded-lg w-full my-6"
            v-for="(item, index) in cartData.data.result"
            :key="index"
            v-if="item.productId[0].isDeleted"
          >
            <div class="lg:flex lg:flex-wrap flex w-full">
              <div class="flex items-center w-full">
                <div class="md:w-1/5 w-1/2 flex items-center">
                  <div class="blur">
                    <img
                      v-if="item.productId[0].productImage"
                      :src="`${$imageURL}/${item.productId[0].productImage}`"
                      alt="Icon"
                      class="cartcrsimg rounded-lg mx-auto"
                    />
                    <img
                      v-else
                      :src="$noIMG"
                      alt="Icon"
                      class="cartcrsimg rounded-lg mx-auto"
                    />
                  </div>
                </div>

                <div class="md:flex items-center w-4/5 justify-between">
                  <div class="blur">
                    <div class="pl-6">
                      <p
                        class="text-black cartname font-bold text-base ellipsis-2 pr-4"
                      >
                        {{ item.productId[0].name }}
                      </p>
                      <p class="font-medium cartfooter sm-fsize12 md:mt-1 mt-1">
                        {{ item.productId[0].brand.name }}
                      </p>
                    </div>
                  </div>
                  <div class="justify-between">
                    <p class="fsize30 sm-fsize25">Product not available....</p>
                  </div>
                </div>

                <div class="w-24 flex justify-center">
                  <feather-icon
                    block
                    icon="Trash2Icon"
                    svgClasses="w-7"
                    class="ftr-bin-clr cursor-pointer"
                    @click="removeCart(item)"
                  ></feather-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="lg:w-1/3 w-full lg:px-4 md:px-4 pt-6">
          <div class="rounded-xl p-4 border-2 border-primary">
            <p class="text-black footertitle font-bold fsize24-14px mb-4">
              Order Summary
            </p>

            <div class="mt-8">
              <div class="flex justify-between">
                <p class="text-lg">Original Price</p>
                <p class="text-black font-semibold">
                  Rs. {{ originalPrice.toFixed(2) }}
                </p>
              </div>
              <!-- <div class="flex justify-between">
                <p class="text-lg">Coupon Discount</p>
                <p class="text-black font-semibold">{{ totalDiscount }}%</p>
              </div> -->
              <template v-if="totalCouponDic">
                <div class="flex justify-between">
                  <p class="text-lg">Coupon Discount</p>
                  <p class="text-black font-semibold">
                    Rs.
                    {{ totalCouponDic.toFixed(2) }}
                  </p>
                </div>
              </template>
              <!-- <template v-if="membershipDisc">
                <div class="flex justify-between">
                  <p class="text-lg">Membership Discount</p>
                  <p class="text-black font-semibold">
                    Rs.
                    {{
                      membershipDisc.toFixed(2) 
                    }}
                  </p>
                </div>
              </template> -->
              <template>
                <div class="flex justify-between">
                  <p class="text-lg">Total Discount</p>
                  <p class="text-black font-semibold">
                    Rs.
                    {{
                      (originalPrice.toFixed(2) - price.toFixed(2)).toFixed(2)
                    }}
                  </p>
                </div>
              </template>
              <div class="flex gap-2 items-center">
                <!-- <p class="text-lg">Coupon</p> -->
                <base-input
                  v-model="couponCode"
                  placeholder="Enter code"
                  class="md:border-0 lg:border-0 my-4 cust-input-fieldset"
                  name="Coupon Code"
                  :disabled="totalCouponDic != ''"
                >
                </base-input>
                <b-button
                  :variant="couponCode.trim() !== '' ? 'primary' : 'dark'"
                  size="sm"
                  class="flex cust-h41px"
                  :disabled="couponCode.trim() === '' || totalCouponDic != ''"
                  @click="applyCoupon"
                >
                  <p
                    class="fsize13 font-small text-white flex h-full items-center"
                  >
                    {{ totalCouponDic != "" ? "Applied" : "Apply Coupon" }}
                  </p>
                </b-button>
              </div>
              <hr class="my-2" />
              <!-- <template>
                <div class="flex justify-between">
                  <p class="text-lg font-semibold text-black">Total Price</p>
                  <p class="text-black font-semibold">Rs.0</p>
                </div>
              </template> -->
              <template>
                <div class="flex justify-between">
                  <p class="text-lg font-semibold text-black">Total Price</p>
                  <p class="text-black font-semibold">
                    Rs. {{ price.toFixed(2) }}
                  </p>
                </div>
              </template>
            </div>
            <b-button
              :disabled="cartData.data.result == 0"
              v-b-modal.modal-6
              :variant="cartData.data.result == 0 ? 'dark' : 'primary'"
              class="w-full border-0 mt-8 py-3 cartchkoutbtn"
              ><p class="fsize16 font-medium text-white">Checkout</p>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { parse } from "path";
import { mapState } from "vuex";
import NoData from "./NoData.vue";

export default {
  components: {
    NoData,
  },
  data() {
    return {
      name: "",
      number: "",
      email: "",
      address1: "",
      landmark: "",
      towncity: "",
      cartValue: "",
      pincode: "",
      state: "",
      price: 0,
      totalPrice: 0,
      totalDiscount: 0,
      currTransactionId: "",
      prodDisc: 0,
      membershipName: "",
      membershipDisc: 0,
      originalPrice: 0,
      couponCode: "",
      lastcouponCode: "",
      itemsArray: [],
      totalCouponDic: "",
    };
  },
  methods: {
    async loadCart() {
      this.originalPrice = 0;
      this.price = 0;
      let loader = this.$loading();
      try {
        let getUserPayload = {
          userId: this.user._id,
        };
        await this.$store.dispatch("auth/getUserByUserId", getUserPayload);
        if (
          this.getUserByUserId.hasOwnProperty("currentMembership") &&
          this.getUserByUserId.currentMembership != null
        ) {
          this.membershipName = this.getUserByUserId.currentMembership.name;
        }
        let data = await this.$store.dispatch("affiliate/getCart");

        if (this.cartData.data.result[0].hasOwnProperty("userAddress")) {
          this.name = this.cartData.data.result[0].userAddress.fullName;
          this.number = this.cartData.data.result[0].userAddress.phoneNumber;
          this.email = this.cartData.data.result[0].userAddress.email;
          this.address1 = this.cartData.data.result[0].userAddress.address;
          this.landmark = this.cartData.data.result[0].userAddress.landMark;
          this.towncity = this.cartData.data.result[0].userAddress.townCity;
          this.pincode = this.cartData.data.result[0].userAddress.pinCode;
          this.state = this.cartData.data.result[0].userAddress.state;
        } else {
          this.name =
            this.getUserByUserId.firstname +
            " " +
            this.getUserByUserId.lastname;
          this.number = this.getUserByUserId.mobile;
          this.email = this.getUserByUserId.email;
        }

        this.cartData.data.result.forEach((e) => {
          if (!e.productId[0].isDeleted && e.productId[0].sku > 0) {
            this.originalPrice += e.qnty * e.productId[0].price;
            if (e.productId[0].membershipDisc[this.membershipName] != null) {
              // console.log("e.productId[0].membershipDisc[this.membershipName]");
              this.membershipDisc +=
                e.qnty *
                ((e.productId[0].discountPrice *
                  e.productId[0].membershipDisc[this.membershipName]) /
                  100);
              this.price +=
                e.qnty *
                (e.productId[0].discountPrice -
                  (e.productId[0].discountPrice *
                    e.productId[0].membershipDisc[this.membershipName]) /
                    100);
            } else {
              this.price += e.qnty * e.productId[0].discountPrice;
            }
          }
        });
        this.totalPrice = this.price.toFixed(2);
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },

    async handleClick() {
      let self = this;
      let prods = [];
      this.cartData.data.result.forEach((e) => {
        Object.assign(e.productId[0], { quantity: e.qnty });
        prods.push(e.productId[0]);
      });
      console.log(prods);

      let userAddress = {
        fullName: this.name,
        phoneNumber: parseInt(this.number),
        email: this.email,
        address: this.address1,
        landMark: this.landmark,
        townCity: this.towncity,
        pinCode: parseInt(this.pincode),
        state: this.state,
      };

      await this.$store.dispatch("affiliate/updateAddress", userAddress);
      // const payload = {
      //   paymentAmt: parseInt(this.totalPrice),
      //   transactionId: "655b102a2ad99b00127f9333",
      //   invoiceId: "order_N2eV08MblaI1gGgG",
      //   paymentStatus: "success",
      //   userId: this.user._id,
      //   itemsArray: prods,
      //   deliveryDetails: userAddress,
      // };
      // const data = await this.$store.dispatch("affiliate/createOrder", payload);
      // return;
      var amount = Number(this.totalPrice) * 100;
      var paymentRecord = async (response) => {
        var responcenew = await this.handlePaymentRecord(response);
        this.currTransactionId = responcenew.data._id;

        if (responcenew) {
          const payload = {
            paymentAmt: parseInt(this.totalPrice),
            transactionId: responcenew.data._id,
            invoiceId: responcenew.data.orderId,
            orderStatus: "success",
            userId: this.user._id,
            itemsArray: prods,
            deliveryDetails: userAddress,
          };
          let loader = this.$loading();
          try {
            const data = await this.$store.dispatch(
              "affiliate/createOrder",
              payload
            );
            if (data.code == 200) {
              let TransPayload = {
                _id: responcenew.data._id,
                transactionstatus: "Success",
              };

              await this.$store.dispatch(
                "transaction/UpdateTransaction",
                TransPayload
              );
              let getUserPayload = {
                userId: this.user._id,
              };
              const getUser = await this.$store.dispatch(
                "auth/getUserByUserId",
                getUserPayload
              );

              loader.close();
              // console.log("payment success");
              const status = await this.$store.dispatch(
                "affiliate/updateOrder",
                {
                  orderId: data.data.order,
                  paymentStatus: "success",
                }
              );
              if (status.code == 200) {
                let prodList = [];
                prods.forEach((e) => {
                  prodList.push(e._id);
                });
                const removeCartItems = await this.$store.dispatch(
                  "affiliate/removeItem",
                  {
                    removeAll: true,
                  }
                );
                await this.loadCart();
                this.$bvModal.hide("modal-6");

                this.$swal.fire({
                  title: "Order Placed!",
                  text: "Your order has been placed Successfully!",
                  icon: "success",
                  showConfirmButton: true,
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                  // timer: 2000,
                });

                this.totalPrice = 0;
                this.name = "";
                this.number = "";
                this.email = "";
                this.address1 = "";
                this.landmark = "";
                this.towncity = "";
                this.pincode = "";
                this.state = "";
                this.totalCouponDic = "";
                this.couponCode = "";
              } else if (status.code == 401) {
                this.$router.push({ name: "signin" });
                this.$swal.fire({
                  title: "Session Expired",
                  text: "Your session has ended and for security reasons, we request you to login again",
                  icon: "warning",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              }
            }
            loader.close();
          } catch (error) {
            loader.close();
            console.log(error);
          }
        }
      };
      this.$store
        .dispatch("payment/CreateOrderPayment", {
          amount: Number(Math.round(amount)),
        })
        .then(async (_) => {
          console.log(_);
          if (Object.keys(_.data).length == 0) {
            // console.log("Payment failed");
            return;
          }
          var options = {
            key: process.env.RAZORPAY_KEY_ID,
            amount: _.data.amount.toString(),
            currency: "INR",
            name: `${this.user.firstname || ""} ${this.user.lastname || ""}`,
            description: `Product Id: ${prods} `,
            order_id: _.data.id,
            handler: function (response) {
              paymentRecord(response);
            },
            prefill: {
              name: `${this.user.firstname || ""} ${this.user.lastname || ""}`,
              email: `${this.user.email || ""}`,
              phone: `${this.user.mobile || ""}`,
            },
          };
          var rzp1 = new Razorpay(options);
          rzp1.on("payment.failed", async function (response) {
            // console.log("FAILEDTRANSACTION");
            self.handleFaliedTransaction();
          });
          rzp1.open();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async handleDcr(item) {
      // console.log(item);
      try {
        // let loader = this.$loading();
        if (item.qnty == 1) {
          this.$swal({
            title: "Are you sure?",
            html: `<p class="text-center">You want to remove product from cart!</p>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#830c81",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, remove it!",
          }).then(async (result) => {
            // console.log(result, "result");
            if (result.value) {
              await this.$store.dispatch("affiliate/updateCart", {
                _id: item._id,
                dcr: true,
              });
              this.loadCart();
            }
          });
        } else {
          await this.$store.dispatch("affiliate/updateCart", {
            _id: item._id,
            dcr: true,
          });
          this.loadCart();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async handleInc(item) {
      try {
        await this.$store.dispatch("affiliate/updateCart", {
          _id: item._id,
          inc: true,
        });

        this.loadCart();
        // this.$notify({
        //     title: "Added",
        //     message: "Product added to cart!!",
        //     type: "success",
        //     duration: "1500",
        //   });
      } catch (err) {
        if (err.response.data.message.includes("Product not available")) {
          this.$swal.fire({
            text: err.response.data.message,
            icon: "error",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
        }
        console.log(err);
      }
    },
    async handlePaymentRecord(responce) {
      let prodList = [];
      this.cartData.data.result.forEach((e) => {
        prodList.push(e.productId[0]._id);
      });
      // console.log(prodList, "handlePaymentRecord");
      try {
        let payload = {
          transactionId: responce.razorpay_signature,
          transactionstatus: "In-Progress",
          transactionMode: "online",
          orderId: responce.razorpay_order_id,
          productId: this.prodList,
          razorpayKey: {
            razorpay_payment_id: responce.razorpay_payment_id,
            razorpay_order_id: responce.razorpay_order_id,
            razorpay_signature: responce.razorpay_signature,
          },
        };
        const transactionrecord = await this.$store.dispatch(
          "transaction/CreateTransaction",
          payload
        );
        this.currTransactionId = transactionrecord.data._id;
        return transactionrecord;
      } catch (err) {
        console.log(err);
      }
    },
    async handleFaliedTransaction() {
      let TransPayload = {
        _id: this.currTransactionId,
        transactionstatus: "Failed",
      };
      let data = await this.$store.dispatch(
        "transaction/UpdateTransaction",
        TransPayload
      );
    },
    removeCart(item) {
      if (item._id.length != 0) {
        this.$swal({
          title: "Are you sure?",
          html: `<p class="text-center">You won't be able to revert this!</p>`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#830c81",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, remove it!",
        }).then(async (result) => {
          console.log(result);
          if (result.value) {
            const data = await this.$store.dispatch("affiliate/removeItem", {
              _id: item._id,
            });
            this.originalPrice = 0;
            this.price = 0;
            this.totalPrice = 0;
            this.loadCart();

            this.$swal.fire({
              title: "Removed!",
              text: "Item has been removed.",
              icon: "success",
              confirmButtonColor: "#830c81",
            });
          }
        });
      }
    },
    async applyCoupon() {
      if (this.lastcouponCode == this.couponCode) {
        return this.$swal.fire({
          // title: "",
          text: "Coupon apply only one time",
          icon: "error",
          confirmButtonColor: "#830c81",
        });
      }
      let payload = {
        couponCode: this.couponCode,
        totalPrice: this.price.toFixed(2),
      };
      try {
        let data = await this.$store.dispatch(
          "subscribe/SubmitCoupon",
          payload
        );
        if (data.data.errormsg !== null) {
          this.$swal.fire({
            // title: "",
            text: data.data.errormsg,
            icon: "error",
            confirmButtonColor: "#830c81",
          });
        } else {
          this.lastcouponCode = this.couponCode;
          this.price = data.data.finalPrice;
          this.totalCouponDic =
            Number(data.data.beforePrice) - Number(data.data.finalPrice);
        }
      } catch (error) {
        console.log(error.response);
        this.$swal.fire({
          // title: "",
          text: error.response.data.message.split(":")[1],
          icon: "error",
          confirmButtonColor: "#830c81",
        });
      }
    },
  },
  computed: {
    ...mapState("affiliate", {
      cartData: "cartData",
    }),
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
  },
  mounted() {
    this.loadCart();
  },
};
</script>
<style>
.blur {
  filter: blur(2px);
  -webkit-filter: blur(2px);
}
.blur1 {
  color: black;
  font-weight: bold;
  z-index: 2;
  /* text-align: center; */
}
.h-553px {
  height: 553px;
}
.fsize30 {
  font-size: 30px;
  /* z-index: 999; */
}
.custbtn {
  padding: 7px 10px !important;
}
.custform .form-group {
  margin-bottom: 0.5rem !important;
}
.custbtn.el-button--primary.is-plain {
  color: white !important;
}
</style>
<!-- 658c269532904622c8f3e346 -->
